<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<script>
import moduleCourseClassExam from "@/store/courseClassExam/moduleCourseClassExam.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleExamType from "@/store/settings/examType/moduleExamType.js";
import moduleCourse from "@/store/course/moduleCourse.js";
import draggable from "vuedraggable"
import moduleCourseExam from "@/store/CourseExam/moduleCourseExam.js";
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
export default {
  components: {
    draggable,
     Datepicker,
     flatPickr ,
     vSelect
  },
  data() {
    return {
        config: {
          dateFormat:'Y-m-d H:i ',
          enableTime: true,
          minDate: new Date(),
        },
      searchCourseExamModel:{},
      examType:0,
      activePrompt:false,
      selected: [],
      isMounted: false,
      // Data Sidebar
      examModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      exam_not_found :false,
      activeTab: 0,
    };
  },
  computed: {
     courseExams() {

      return this.$store.state.CourseExamList.CourseExams;
    },
      courses() {
      return this.$store.state.courseList.courses;
    },
     examTypes() {
       if(this.$store.state.examTypeList!=undefined)
          return this.$store.state.examTypeList.examTypes;
    },
    courseClass() {
      return this.$store.state.courseClassList.courseClass;
    },
    questions:{
      get() {
             return this.$store.state.courseClassExamList.questions;
        },
        set(value) {
          this.$store.commit("courseClassExamList/SET_Question",value);
        }
    },

    isGenerateFormValid()
    {
      return this.examModel.CourseID&&this.examModel.ExamTypeID;
    },
    isFormValid()
    {
        return true;
    }
  },

  methods: {
    initValues()
    {
       this.examModel = {};
    },
    GenerateQuestion()
    {
        this.$vs.loading();
        this.$store.dispatch("courseClassExamList/GenerateQuestion",  this.examModel).then(()=>{
            this.$vs.loading.close();
        }).catch(err => {
             this.$vs.loading.close();
              console.error(err);
            });
    },
    // TotalExamTime()
    // {
    //   debugger
    //   this.examModel.TimeOfExamInMinutes=0;
    //     this.questions.forEach(element => {
    //       this.examModel.TimeOfExamInMinutes = this.examModel.TimeOfExamInMinutes+ element.TimeOfQuestionInMinute;
    //     });
    // },

    changeCourseClass()
    {
      debugger
      var CourseClassIndex= this.courseClass.findIndex((p) => p.ID == this.examModel.CourseClassID);
      if(CourseClassIndex!=-1)
      {

        var CourseClass=this.courseClass[CourseClassIndex];
        this.examModel.CourseID = CourseClass.CourseID
        if(CourseClass.Course!=null||CourseClass.Course!=undefined)
             this.examModel.CourseName = CourseClass.Course.Name;

        this.getCourseExam();
      }
    },
  changeCourse()
  {
     this.getCourseExam();
  },
  changeExamType()
  {
  this.getCourseExam();
  },
    ValidateQuestionWeight()
    {

        var totalWeight=0;
        for(var i=0;i < this.questions.length;i++)
           if(this.questions[i].Weight==null||this.questions[i].Weight=="")
           {
              this.notifyAlert("danger",this.$t("Error"),this.$t("PleaseEnterAllQuestionWeight"));
             return false;
           }
           else
               totalWeight+= parseFloat(this.questions[i].Weight);
          if(totalWeight==100)
             return true;
          else
          {
            this.notifyAlert("danger",this.$t("Error"),this.$t("TotalExamPercentagemustbe100"));
              return false;
          }
    },
 ValidateQuestionTime()
    {
        for(var i=0;i < this.questions.length;i++){
           if(this.questions[i].TimeOfQuestionInMinute==null||this.questions[i].TimeOfQuestionInMinute=="")
           {
              this.notifyAlert("danger",this.$t("Error"),this.$t("PleaseEnterAllQuestionTime"));
             return false;
           }
        }
          return true;
    },

    submitData() {

     this.$validator.validateAll().then(result => {
        if (result&&this.ValidateQuestionWeight()&&this.ValidateQuestionTime()) {
         this.examModel.CourseClassExamQuestions=this.$store.state.courseClassExamList.questions.map(function(val){ var obj={};
            obj=val;
           obj.CourseClassExamQuestionAnswers = val.CourseQuestionBankAnswers;
           obj.CourseClassExamQuestionAttachments = val.CourseQuestionBankAttachments;
         return obj; });
            if(this.examType==1)
              this.examModel.CourseClassID=null;
          if (this.examModel.ID !== null && this.examModel.ID >= 0) {
               this.$vs.loading();
            this.$store.dispatch("courseClassExamList/updateItem", this.examModel).then(res => {
                console.error(res);
                 this.$vs.loading.close();
                 this.$router.push({name:"ExamGeneration"});
               this.initValues();
           }).catch(err => {
              this.$vs.loading.close();
              console.error(err);
            });

          }
          else {
            delete this.examModel.ID;
            this.examModel.popularity = 0;
               this.$vs.loading();
            this.$store.dispatch("courseClassExamList/addItem", this.examModel)
            .then(res => {
                console.error(res);
                 this.$vs.loading.close();
              this.$router.push({name:"ExamGeneration"});
               this.initValues();
           }).catch(err => {
              this.$vs.loading.close();
              this.$vs.notify({
                fixed:true,
                title: 'Error',
                text: this.$t("Unexpectederrorpleasetryagain"),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              console.error(err);
            });
          }

        }
      });
    },
   notifyAlert(color,title,text) {
        this.$vs.notify({
          fixed:true,
            color: color,
            title: title,
            text: text
        });
      },

      getCourseExam()
      {
        if(this.examModel.CourseID&&this.examModel.ExamTypeID)
        {
            this.searchCourseExamModel.CourseID=this.examModel.CourseID;
           this.searchCourseExamModel.ExamTypeID=this.examModel.ExamTypeID;
           this.$store.dispatch("CourseExamList/searchCourseExam",this.searchCourseExamModel);
        }
      },
      CalcualteTotalTime()
      {
        debugger
        this.examModel.TimeOfExamInMinutes=0;
         this.questions.forEach(element => {
           if(element.TimeOfQuestionInMinute!=undefined)
              this.examModel.TimeOfExamInMinutes+=parseInt( element.TimeOfQuestionInMinute);
         });


      }
  },

  created() {

    if (!moduleCourseClassExam.isRegistered) {
      this.$store.registerModule("courseClassExamList", moduleCourseClassExam);
      moduleCourseClassExam.isRegistered = true;
    }

    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }

     if (!moduleExamType.isRegistered) {
      this.$store.registerModule("examTypeList", moduleExamType);
      moduleExamType.isRegistered = true;
    }
      if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    if (!moduleCourseExam.isRegistered) {
      this.$store.registerModule("CourseExamList", moduleCourseExam);
      moduleCourseExam.isRegistered = true;
    }
     this.$store.commit("CourseExamList/SET_CourseExam",[]);

    this.$store.dispatch("courseList/fetchDataListItems");
    this.$store.dispatch("examTypeList/fetchDataListItems");
    this.$store.dispatch("courseClassList/getCourseClassForDisplayName");

     this.initValues();
     const ID = this.$route.params.ID;

     const CourseClassID = this.$route.params.CourseClassID;

     if(CourseClassID!=undefined)
        this.examModel.CourseClassID=CourseClassID;

     this.changeCourseClass();

     this.$store.commit("courseClassExamList/SET_Question", []);

     if(ID!=undefined)
     {

      this.$store.dispatch("courseClassExamList/GetItemByID", ID)
      .then(res => {
         this.examModel = res.data;
          this.examModel.CourseName =  this.examModel.Course.Name;
          var mapedQuestions=this.examModel.CourseClassExamQuestions.map(function(val){ var obj={};
           obj=val;
           obj.CourseQuestionBankAnswers=val.CourseClassExamQuestionAnswers;
           obj.CourseQuestionBankAttachments=val.CourseClassExamQuestionAttachments;
          return obj; });
         this.$store.commit("courseClassExamList/SET_Question",mapedQuestions);
       })
      .catch(err => {

          if(err.response.status === 404) {
            this.exam_not_found = true
            return
          }
          console.error(err)
        })
     }

  },
  mounted() {
    this.isMounted = true;
  },

};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-alert color="danger" title="Exam Not Found" :active.sync="exam_not_found">
      <span>Exam record with id: {{ $route.params.Id }} not found. </span>
      <span>
        <span>{{$t('Check')}} </span><router-link :to="{name:'ExamGeneration'}" class="text-inherit underline">{{$t('AllExams')}}</router-link>
      </span>
    </vs-alert>

   <div  v-if="!exam_not_found||(this.$route.params.ID&&this.examModel.ID)">
     <vx-card title="Exam Main Date">

      <div slot="no-body" class="tabs-container px-6 p-6">
         <div class="vx-row">

            <!-- <vs-select  class="vx-col lg:w-1/3 w-full mt-5" label="Generation Type" v-model="examType" >
              <vs-select-item key="0" value="0" text="Course Class Exam"  />
              <vs-select-item key="1" value="1" text="General Exam"  />
            </vs-select> -->
            <div class="vx-col lg:w-1/3 w-full mt-5">
     <p>{{$t('ExamType')}}</p>
          <v-select
            label="Name"
            v-model="examModel.ExamTypeID"
            :options="examTypes"
            class="w-full"
            :reduce="Course => Course.ID"
            @input="changeExamType"
          />
            </div>

   <div class="vx-col lg:w-1/3 w-full mt-5" v-if="examModel.ExamTypeID!=7">
     <p>{{$t('CourseClass')}}</p>
          <v-select
            label="DisplayName"
            v-model="examModel.CourseClassID"
            :options="courseClass"
            class="w-full"
            :reduce="Course => Course.ID"
            @input="changeCourseClass"
          />
            </div>

               <div class="vx-col lg:w-1/3 w-full mt-5" v-if="examModel.ExamTypeID!=7">
              <p >{{$t('Course')}}</p>
             <vs-input   class="vx-col w-full" type="text" name="CourseName" v-if="examModel.ExamTypeID!=7" :disabled="true"  v-model="examModel.CourseName" />
           </div>
           <div class="vx-col lg:w-1/3 w-full mt-5" v-if="examModel.ExamTypeID==7">
     <p>{{$t('Course')}} </p>
          <v-select
            label="Name"
            v-model="examModel.CourseID"
            :options="courses"
            class="w-full"
            autocomplete
            :reduce="Course => Course.ID"
          />
            </div>
             <!-- <vs-select autocomplete class="vx-col lg:w-1/3 w-full mt-5" label="Course" v-model="examModel.CourseID"  v-if="examModel.ExamTypeID==1" @change="changeCourse()">
              <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
            </vs-select> -->
            <div class="vx-row w-full " style="padding-left:20px" v-if="examModel.ExamTypeID!=7">
<div class="vx-col lg:w-1/3 w-full mt-5" flex>
     <p >{{$t('Exams')}} </p>
          <v-select
            label="Name"
            v-model="examModel.CourseExamID"
            :options="courseExams"
            class="w-full"
            autocomplete
            :reduce="Exam => Exam.ID"
          />
            </div>
             <!-- <vs-select  autocomplete   class="vx-col lg:w-1/3 w-full mt-5" label="Exams" v-model="examModel.CourseExamID" >
               <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courseExams" />
            </vs-select> -->
             <div class="vx-col lg:w-1/3 w-full mt-5" flex>
            <p>Time Of Exam In Minutes </p>
              <vs-input  type="number" class="w-full" :disabled="true" v-model="examModel.TimeOfExamInMinutes" name="Name"/>

            </div>

                <div class="vx-col lg:w-1/3 w-full mt-5" flex>

                        <label for="Exam Start Date"   class="vs-input--label">{{$t('ExamStartDate')}}</label>

                  <flat-pickr  :config="config" :placeholder="$t('ExamStartDate')" class="w-full" v-model="examModel.ExamStartDate"   name="Exam Start Date"></flat-pickr>
                  <span class="text-danger text-sm" v-show="errors.has('Exam Start Date')">{{ errors.first('Exam Start Date') }}</span>
                </div>

            </div>


          </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="mr-6  justify-end" @click="GenerateQuestion" :disabled="(examModel.CourseID==undefined||!examModel.ExamTypeID||examModel.CourseExamID==undefined)&&(examModel.ExamTypeID!=7)">Generate</vs-button>
            </div>
          </div>
       </div>
    </div>
    </vx-card>
      <!-- v-if="examModel.CourseClassExamQuestions" -->
      <vx-card title="Generate Question" class="mt-10" v-if="questions.length>0">
      <draggable v-model="questions" group="questions" @start="drag=true" @end="drag=false">

      <vx-card class="p-5 mt-5" v-for="(item,index) in questions" :key="index">
        <div>
          <h6 v-if="item.QuestionTypeID==1"> {{$t('Text')}}</h6>
          <h6 v-if="item.QuestionTypeID==3">{{$t('MultiChoose')}}</h6>
          <h6 v-if="item.QuestionTypeID==2"> {{$t('TrueFalse')}}</h6>
          <div class="vx-row">
             <label class="vx-col lg:w-1/2 mt-3 pl-3">{{index+1}}-{{item.QuestionText}}</label>
             <div class="vx-row "  >
           <div class="vx-col" >  {{$t('Weight')}}<vs-input  class="vx-col" aria-placeholder="Weight" v-model="item.Weight"/></div>
             <div class="vx-col" >  {{$t('TimeInMinute')}}<vs-input type="number" class="vx-col" @change="CalcualteTotalTime()" aria-placeholder="TimeOfQuestionInMinute" v-model="item.TimeOfQuestionInMinute"/></div>
          </div>
          </div>
        </div>

        <div class="pl-5">
           <div v-for="(ans,indx) in item.CourseQuestionBankAnswers" :key="indx">
              <label>-{{ans.AnswerText}}</label>
           </div>
        </div>
      </vx-card>
      </draggable>
       </vx-card>

     <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
           <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
        <vs-button type="border" color="danger" :to="{name:'ExamGeneration'}">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
      </div>
    </div>
   </div>
 </template>

